.report-mode-chart ::ng-deep .chart-wrapper{min-height:210px}
/*# sourceMappingURL=day-of-week-chart.component-ZLQUAQZM.css.map */
